import { render, staticRenderFns } from "./MultiplePriceToggleContainer.vue?vue&type=template&id=04c396ea&scoped=true&"
import script from "./MultiplePriceToggleContainer.vue?vue&type=script&lang=js&"
export * from "./MultiplePriceToggleContainer.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePriceToggleContainer.vue?vue&type=style&index=0&id=04c396ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c396ea",
  null
  
)

export default component.exports